import React from 'react';
import Pagination from '../layout/Pagination';
import { PAGE_SIZE } from '../../config/constants';

const ListFooter = ({
  total = 0,
  totalPages = 0,
  page,
  setPage,
  isLoading = false,
  isEmpty = false,
  itemLabel = 'items',
  pageSize = PAGE_SIZE,
}) => {
  const startRange = (page - 1) * pageSize + 1;
  const endRange = Math.min(page * pageSize, total);

  return (
    <div className="flex flex-col-reverse gap-2 sm:flex-row my-4 justify-between lg:justify-center lg:gap-4 items-center md:items-center">
      <div className="text-[#868C98] max-w-[50%] text-sm sm:items-center flex flex-col overflow-hidden">
        {isLoading || isEmpty ? null : (
          <p className="mr-2 mb-2 whitespace-nowrap overflow-hidden">
            Showing <span className="font-bold">{startRange}</span> - <span className="font-bold">{endRange}</span> of{' '}
            <span className="font-bold">{total}</span> {itemLabel}
          </p>
        )}
        <Pagination total={total} totalPages={totalPages} page={page} setPage={setPage} />
      </div>
    </div>
  );
};

export default ListFooter;
